/* eslint-disable react/prop-types */
/* eslint-disable no-param-reassign */
import React, { CSSProperties } from 'react';
import ReactDOM, { createPortal } from 'react-dom';
import Style from './index.less';
import classNames from 'classnames';
import { STATUS_BAR_HEIGHT } from '@editor/src/js/constants';
/**
 * DropDown另外一种实现，比dui有3大优点，而且效果基本和dui一致
 * 1， 不抢焦点
 * 2， 不影响原来控件布局
 * 3， 不会展示前render下拉内容
 * 4， 可以通过改变belongID实现多个控件绑定一个dropDown
 *
 * props参数文档：
 * anchorPoint{x:0,y:0} 或 anchorRect{x:0,y:0,width:0,height:0} : 锚点，当没有指定belongID时，可以指定锚点，标示一个位置
 * belongID ：所属的dom元素的id，即从哪里打开。如果指定锚点后，可以不用传
 * dropContent: 如果不指定children，可以指定dropContent来展示内容
 * hasShadow：是否给drop内容加上阴影和上下间距
 * aligment : 'left' 'right' 'top' 'bottom',和所属dom元素的对齐方式,'screenCenter',屏幕正中
 * autoAlign : boolean值，为true的话会根据上下空间的大小自动展示为top还是bottom，如果有autoAlignPriority参数则提供优先方向
 * autoAlignPriority?: 'left' 'right' 'top' 'bottom', 优先向此方向对齐，空间不足时向反方向对齐, 目前仅支持'top'。
 * autoAdjust: 是否自动调整drop内容位置，即设置了alginment之后，如果内容超出了body区域，会自动调整尽量显示在body区域内，默认为true
 * matchWidth : 下拉内容是否和所属dom等宽
 * onVisibleChange : 显示隐藏回调监听
 * disabled ：不可打开关闭dropDown
 * scrollable :是否自动计算可否滚动
 * hasTransform : 是否去掉动画的transform属性，dropDown嵌套需要去掉transform
 * shadowType ： 'menu'为menu的阴影效果
 * center : 在所属dom居中位置显示
 * offsetX：正数向右，负数向左偏移
 * offsetY：正数向下，负数向上偏移
 * ignoreBottomOffsetY: alignment === 'bottom'时，忽略offsetY
 * isTransparent: bool, 背景是否为透明色
 * disableBodyClose: bool, 是否禁用点击body时自动关闭
 * autoClose： 点击其他区域是否关闭。默认为true
 * zIndex: 设置zIndex，
 * autoOffsetY : 自动调整offsetY。暂时只支持一种
 * autoOffsetMode: 自动调整offset的条件，model=1为当下拉内容宽度小于anchorRect宽度时。暂时只支持一种。此参数存在时会使元素尽量显示在body区域内。
 * containerId:可以指定容器
 * maxHeight: 可以指定最大高度
 * style: 下拉列表最外层样式
 * alignDirection: 'tb' | 'lr', 弹出框相对锚点的方向 '上下' | '左右', 默认为'上下'
 * centerAlignByWidth: 20240919优化：仅当弹窗宽度大于锚点宽度时，居中显示。只有 alignDirection=tb 时生效，优先级低于 ‘aligment’ 和 ‘center’
 */

interface DropdownProps {
    belongID?: string;
    closeWhenHide?: boolean;
    aligment?: string;
    zIndex?: CSSProperties['zIndex'];
    style?: CSSProperties;
    hasShadow?: boolean;
    shadowType?: string;
    hasTransform?: boolean;
    isTransparent?: boolean;
    containerId?: string;
    autoClose?: boolean;
    disableBodyClose?: boolean;
    maxLevel?: number;
    disabled?: boolean;
    onVisibleChange?: (visible) => void;
    maxHeight?: number;
    matchWidth?: boolean;
    scrollable?: boolean;
    alignDirection?: string;
    autoAlign?: boolean;
    autoAlignPriority?: string;
    autoCustomLimitOffsetY?: number;
    center?: string|boolean;
    autoAdjust?: boolean;
    offsetX?: number;
    offsetY?: number;
    ignoreBottomOffsetY?: boolean;
    autoOffsetMode?: number;
    autoOffsetY?: number;
    dropContent?: any;
    anchorPoint?: any;
    anchorRect?: any;
    centerAlignByWidth?: boolean;
}

interface DropdownState {
    isShown: boolean;
    hideAnimating: boolean;
    config: any;
    dropContent: any;
}

export default class Dropdown extends React.Component<DropdownProps, DropdownState> {
    public static index = 0;

    /**
     * 使用方法创建DropDown，并返回一个接口对象
     *
     * Dropdown.create({
            anchorPoint: {x:100,y:100},
            dropContent:<LinkEditMenu />,
        }).show()
     *
     * @param config
     */
    public static create(config) {
        const div = document.createElement('div');
        // eslint-disable-next-line react/no-render-return-value
        let instance: Dropdown|null = ReactDOM.render(<Dropdown
            {...config} closeWhenHide={true}/>, div) as unknown as Dropdown;

        function show() {
            if (instance) {
                instance.show();
            }
        }

        function close() {
            if (instance) {
                instance.setDisable(false);
                if (instance.isShown()) {
                    instance.hide(() => {
                        ReactDOM.unmountComponentAtNode(div);
                    });
                } else {
                    ReactDOM.unmountComponentAtNode(div);
                }
            }
            instance = null;
        }

        function isShown() {
            if (instance) {
                return instance.isShown();
            }
            return false;
        }

        function setDisable(dsiable) {
            if (instance) {
                instance.setDisable(dsiable);
            }
        }

        function updateAnchorRect(rect) {
            if (instance) {
                instance.updateAnchorRect(rect);
            }
        }

        function updateAnchorPoint(point) {
            if (instance) {
                instance.updateAnchorPoint(point);
            }
        }

        function updateDropContent(dropContent, anchorRect?) {
            if (instance) {
                instance.updateDropContent(dropContent, anchorRect);
            }
        }

        return {
            show, close, isShown, setDisable, updateAnchorRect, updateAnchorPoint, updateDropContent,
        };
    }

    private id: string;
    private firstRender: boolean;
    private hiding: boolean;
    private stopHidingFlag: boolean;
    private anchorPoint;
    private anchorRect;
    private unmount: boolean;
    private alignment: string;
    private dropDom: HTMLElement|null;
    private downX: number;
    private downY: number;
    private disabled?: boolean;
    private oldLeft: number;
    private oldRight: number;

    public constructor(props: DropdownProps, context) {
        super(props, context);

        this.state = {
            isShown: false,
            hideAnimating: false,
            config: {},  // drop内容位置，大小，是否可滚动等等
            dropContent: props.dropContent,
        };

        this.id = `custom-drop-down-id-${Dropdown.index}`;
        Dropdown.index += 1;
        this.firstRender = true;  // 第一次不渲染内容
        this.hiding = false;
        this.stopHidingFlag = false;

        this.anchorPoint = props.anchorPoint;
        this.anchorRect = props.anchorRect;
    }

    public updateAnchorRect = (anchorRect) => {
        this.anchorRect = anchorRect;
        this.autoAdjustLoc();
    };

    public updateAnchorPoint = (anchorPoint) => {
        this.anchorPoint = anchorPoint;
        this.autoAdjustLoc();
    };

    public updateDropContent = (dropContent, anchorRect = this.anchorRect) => {
        this.anchorRect = anchorRect;
        this.setState({
            dropContent,
        }, () => {
            this.autoAdjustLoc();
        });
    };

    public hide = (callBack?) => {
        if (this.props.disabled || this.disabled) {
            return;
        }
        // console.log('hide menu');
        if (this.state.isShown) {
            // @ts-ignore
            // eslint-disable-next-line react/no-direct-mutation-state
            this.state.hideAnimating = true;
            setTimeout(() => {
                if (this.unmount) return;
                this.setState({
                    hideAnimating: false, // 动画结束
                });
            }, 250);
            this.setState({
                isShown: false,
            }, () => {
                this.onVisibleChange(false);
                callBack?.();
            });
            this.removeListener();
        }
    };

    public componentWillUnmount() {
        this.unmount = true;
        this.removeListener();
    }

    // eslint-disable-next-line react/no-deprecated
    public componentWillReceiveProps(nextProps) {
        if (!this.firstRender) {
            this.hookBelongDomClick(nextProps.belongID);

            this.anchorPoint = nextProps.anchorPoint;
            this.anchorRect = nextProps.anchorRect;
        }
    }

    /* eslint-disable complexity */
    public render() {
        if (!this.state.config) return null;

        let needHide = false;
        if (!this.state.isShown && this.firstRender) {
            this.hookBelongDomClick(this.props.belongID);
            return null;
        } if (this.state.isShown) {
            needHide = this.firstRender; // 第一次isShown时，页面没有动画，所以这次hide，让其下次render时show让动画出现
            this.firstRender = false;
        }

        if (this.props.closeWhenHide) {
            if (this.state.isShown || this.state.hideAnimating) {
                // do nothing
            } else {
                return null;
            }
        }

        const { top } = this.state.config;
        const { bottom } = this.state.config;
        const { left } = this.state.config;
        const { right } = this.state.config;
        const { width } = this.state.config;
        const { height } = this.state.config;

        // let transformOrigin = this.props.aligment === 'top' ? 'center bottom' : 'center top';
        const hideTransform = this.props.aligment === 'top' || this.alignment === 'top' ? 'drop-down-hide-transform-top' : 'drop-down-hide-transform';

        const dropStyle: CSSProperties = {
            left, top, bottom, right, width, height, zIndex: this.props.zIndex,
            userSelect: 'none', WebkitUserSelect: 'none',
            ...(this.props.style || {}),
        };

        const hasShadow = typeof (this.props.hasShadow) === 'undefined' ? true : this.props.hasShadow;
        const menuShadow = this.props.shadowType || 'default';
        const hasTransform = typeof (this.props.hasTransform) === 'undefined' ? true : this.props.hasTransform;
        const isTransparent = typeof (this.props.isTransparent) === 'undefined' ? false : this.props.isTransparent;

        let container = document.body;
        if (this.props.containerId) {
            const c = document.getElementById(this.props.containerId);
            if (c)container = c;
        }

        const dropClass = classNames({
            [Style['drop-down']]: true,
            [Style['drop-down-show-transform']]: hasTransform,
            [Style['drop-down-hidden']]: !this.state.isShown || needHide,
            [Style[hideTransform]]: (!this.state.isShown || needHide) && hasTransform,
            [Style['drop-down-shadow']]: hasShadow && !menuShadow,
            [Style['drop-down-menu-shadow']]: hasShadow && menuShadow,
            'menu-scroll': this.state.config.scrollable,
            [Style['drop-down-background']]: !isTransparent,
        });

        return createPortal(
            <div id={this.id} ref={(ref) => {
                this.dropDom = ref;
            }} style={dropStyle} className={dropClass}
            // 表示可以获取到焦点，主要用于辅助文字被抢焦点的重置
            tabIndex={-1}
            >
                {(this.state.isShown || this.state.hideAnimating)
                    ? (this.state.dropContent || this.props.children) : null}
            </div>, // 塞进传送门的JSX
            container, // 传送门的另一端DOM node
        );
    }

    public isShown = () => this.state.isShown;

    public show = () => {
        if (this.props.disabled || this.disabled) {
            return;
        }
        if (!this.state.isShown) {
            document.addEventListener('click', this.bodyClickHandler);
            document.addEventListener('mousedown', this.handleMouseDown);
            window.addEventListener('resize', this.resize);
            this.setState({
                isShown: true,
                config: { left: 0, top: 0 },
            }, () => {
                this.onVisibleChange(true);
                this.autoAdjustLoc();
            });
        } else {
            const config = this.getNewConfig();
            if (this.hiding && config  && (this.oldLeft !== config.left
                || this.oldRight !== config.right)) {  // 当做新打开
                this.hiding = false;

                this.setState({
                    config,
                }, () => {
                    this.autoAdjustLoc(config);
                });
            }
        }
    };

    public stopHiding = () => {
        this.stopHidingFlag = true;
    };

    private removeListener = () => {
        // 事件挂载到body上，react合成事件中不好阻止冒泡
        document.removeEventListener('click', this.bodyClickHandler);
        document.removeEventListener('mousedown', this.handleMouseDown);
        window.removeEventListener('resize', this.resize);
    };

    private hookBelongDomClick(belongID) {
        if (!belongID) {
            return;
        }
        // 等待DOM OK
        let checkCount = 0;
        const timer = setInterval(() => {
            checkCount += 1;
            const belongDom = document.getElementById(belongID);
            if (belongDom) {
                // 给DOM绑定点击事件
                belongDom.onclick = () => {
                    setTimeout(() => {
                        this.show();
                    }, 20);
                };
                clearInterval(timer);
            }
            if (checkCount > 10) {
                clearInterval(timer);
            }
        }, 500);
    }

    private bodyClickHandler = (e) => {
        const autoClose = typeof (this.props.autoClose) === 'undefined' ? true : this.props.autoClose;
        if (!autoClose) {
            return;
        }
        // 延迟一下，让body里的元素先执行click
        this.hiding = true;
        setTimeout(() => {
            if (!this.props.disableBodyClose && this.state.isShown && this.hiding && !this.stopHidingFlag) {
                this.hiding = false;
                let clickOnMenu = false;
                if (this.isClickOnContent(this.downX, this.downY)) {
                    clickOnMenu = true;
                } else {
                    clickOnMenu = this.clickOnMenu(e, this.props.maxLevel || 20);
                }
                if (!clickOnMenu) {
                    this.hide();
                }
            } else {
                this.stopHidingFlag = false;
            }
        }, 50);
    };

    private isClickOnContent = (x, y) => {
        if (this.dropDom) {
            // let child = this.dropDom.childNodes[0];
            const rect = this.dropDom.getBoundingClientRect();
            if (x >= rect.left && x <= rect.right
                && y >= rect.top && y <= rect.bottom) {
                return true;
            }
        }
        return false;
    };

    // 点击的位置是否在菜单组件上
    private clickOnMenu = (e, maxLevel) => {
        let curDom = e.target;
        let level = 0;
        while (curDom && level < maxLevel) {
            curDom = curDom.parentNode;
            level += level;
            if (curDom?.id && curDom.id.indexOf(this.id) >= 0) {
                return true;
            }
        }
        return false;
    };

    private resize = () => {
        const autoClose = typeof (this.props.autoClose) === 'undefined' ? true : this.props.autoClose;
        if (autoClose) {
            this.hide();
        }
    };

    private setDisable = (disable) => {
        this.disabled = disable;
    };

    private getReactWithPoint = (point) => {
        const x = point.x || 0;
        const y = point.y || 0;

        return {
            left: x,
            top: y,
            width: 0,
            height: 0,
            right: x,
            bottom: y,
        };
    };

    private getReactWithRect = (rect) => {
        const x = rect.x || 0;
        const y = rect.y || 0;
        const w = rect.width || 0;
        const h = rect.height || 0;

        return {
            left: x,
            top: y,
            width: w,
            height: h,
            right: x + w,
            bottom: y + h,
        };
    };

    private getRect() {
        let rect;
        if (this.props.belongID) {
            const belongDom = document.getElementById(this.props.belongID);
            if (belongDom) {
                rect = belongDom.getBoundingClientRect();
            }
        } else if (this.anchorPoint) {
            rect = this.getReactWithPoint(this.anchorPoint);
        } else if (this.anchorRect) {
            rect = this.getReactWithRect(this.anchorRect);
        }
        return rect;
    }

    private onVisibleChange = (visible) => {
        if (this.props.onVisibleChange) {
            this.props.onVisibleChange(visible);
        }
    };

    private getMaxHeight = (rect, isAlignTop) => {
        if (isAlignTop || !rect) {
            return this.props.maxHeight || 700;
        }
        const { height, top } = rect;
        const maxHeight = window.innerHeight - height - top - STATUS_BAR_HEIGHT - 16;
        if (this.props.maxHeight) {
            return Math.min(maxHeight, this.props.maxHeight);
        }
        return maxHeight;
    };

    private getNewConfig = () => {
        const { dropDom } = this;
        const anchorRect = this.getRect();

        if (dropDom && anchorRect) {
            const dropRect = dropDom.getBoundingClientRect();
            let vh = document.body.clientHeight;
            let vw = document.body.clientWidth;

            if (this.props.containerId) {
                const c = document.getElementById(this.props.containerId);
                if (c) {
                    const bound = c.getBoundingClientRect();
                    vh = bound.height;
                    vw = bound.width;
                }
            }

            const config: any = {};

            // 1.调整上下位置
            this.handleAutoAlign(anchorRect, vh, dropRect, config);

            // 2.调整显示高度和宽度
            const isAlignTop = this.props.aligment === 'top' || this.alignment === 'top';
            const maxHeight = this.getMaxHeight(anchorRect, isAlignTop);
            this.handleAdjustHeight(dropRect, config, vh, maxHeight);
            if (this.props.matchWidth) {
                config.width = dropRect.width;
            }

            // 3. 调整左右位置
            this.handleAligment(config, vw, vh, anchorRect, dropRect);

            this.handleAutoAdjust(config, dropRect, vw);

            this.handleOffset(config);

            this.handleAutoOffset(dropRect, anchorRect, config, vh);

            return config;
        }

        return null;
    };

    /* eslint-disable complexity */
    private handleAdjustHeight(dropRect, config, vh, maxHeight) {
        const scrollable = typeof (this.props.scrollable) === 'undefined' ? true : this.props.scrollable;
        if (scrollable) {
            const isAlignTop = this.props.aligment === 'top' || this.alignment === 'top';
            const menuH = dropRect.height;
            if (isAlignTop) {
                const { bottom } = config;
                if (bottom + menuH >= vh || menuH >= maxHeight) {
                    config.scrollable = true;
                    if (menuH >= maxHeight && maxHeight < vh - bottom) {
                        config.height = maxHeight;
                    } else {
                        config.height = vh - bottom - 6;
                    }
                }
            } else {
                const { top = 0 } = config;
                if (top + menuH >= vh || menuH >= maxHeight) {
                    config.scrollable = true;
                    if (menuH >= maxHeight && maxHeight < vh - top) {
                        config.height = maxHeight;
                    } else {
                        config.height = vh - top - 6;
                    }
                }
            }
        }
    }

    private handleAutoAlign(anchorRect, vh, dropRect, config) {
        if (this.props.alignDirection === 'lr') {
            config.top = anchorRect.top;
            return;
        }
        const top = anchorRect.bottom + 4;
        const bottom = vh - anchorRect.top + 4;
        const menuH = dropRect.height;
        const bottomOffset = vh - top - STATUS_BAR_HEIGHT - 16;  // 底部bar计入bottomOffset
        const topOffset = vh - bottom;
        if (this.props.autoAlign) {
            if (this.props.autoAlignPriority === 'top') {
                // 自动调整：优先向上显示
                this.processAutoAlignTopConfig(bottomOffset, menuH, topOffset, config, bottom, top);
            } else {
                // 自动调整：下方能显示默认向下显示，否则向上显示
                this.processAutoAlignConfig(bottomOffset, menuH, topOffset, config, bottom, top);
            }
        } else if (this.props.aligment === 'top') {
            config.bottom = bottom;
        } else {
            config.top = top;
        }
    }

    private processAutoAlignTopConfig(bottomOffset, menuH, topOffset, config, bottom, top) {
        // 增加自定义偏移
        if (this.props.autoCustomLimitOffsetY) {
            menuH += this.props.autoCustomLimitOffsetY;
        }

        if (bottomOffset <= menuH && topOffset <= menuH) {
            // 上下都无法放置，优先放在上面
            config.top = this.props.autoCustomLimitOffsetY;
            this.alignment = 'top';
        } else if (topOffset > menuH) {
            config.bottom = bottom;
            this.alignment = 'top';
        } else if (bottomOffset > menuH) {
            config.top = top;
            this.alignment = 'bottom';
        }
    }

    private processAutoAlignConfig(bottomOffset, menuH, topOffset, config, bottom, top) {
        if (bottomOffset <= menuH && topOffset <= menuH) {
            // 上下都无法放置，哪边高放置哪边;
            if (topOffset > bottomOffset) {
                config.bottom = bottom;
                this.alignment = 'top';
            } else {
                config.top = top;
                this.alignment = 'bottom';
            }
        } else if (bottomOffset > menuH) {
            config.top = top;
            this.alignment = 'bottom';
        } else if (topOffset > menuH) {
            config.bottom = bottom;
            this.alignment = 'top';
        }
    }

    private handleAligment(config, vw, vh, anchorRect, dropRect) {
        if (this.props.alignDirection === 'lr') {
            config.left = anchorRect.left + anchorRect.width + 4;
            return;
        }
        if (this.props.aligment === 'screenCenter') {
            config.left = vw / 2;
            config.top = vh / 2;
        }

        if (this.props.center) {
            const left = anchorRect.left + (anchorRect.width / 2);
            config.left = left - (dropRect.width / 2);
        } else if (this.props.aligment === 'right') {
            config.right = vw - anchorRect.right;
        } else {
            // 默认左对齐
            config.left = anchorRect.left;
            if (this.props.centerAlignByWidth && dropRect.width > anchorRect.width) {
                // 宽度过宽时居中
                config.left -= (dropRect.width - anchorRect.width) / 2;
            }
        }
    }

    private handleAutoAdjust(config, dropRect, vw) {
        const autoAdjust = typeof (this.props.autoAdjust) === 'undefined' ? true : this.props.autoAdjust;
        if (autoAdjust) {
            if (config.left) {  // 超出左右边界位置调整
                if (config.left + dropRect.width > vw) {
                    config.left -= (config.left + dropRect.width + 4) - vw;
                } else if (config.left < 4) {
                    config.left = 4;
                }
            } else if (config.right) { // 超出左右边界位置调整
                if (vw - config.right < dropRect.width) {
                    config.right -= dropRect.width - (vw - config.right) + 4;
                }
                if (config.right < 4) {
                    config.right = 4;
                }
            }
        }
    }

    private handleOffset(config) {
        if (this.props.offsetX) {  // 调整x轴offset
            if (config.left) {
                config.left += this.props.offsetX;
            } else if (config.right) {
                config.right -= this.props.offsetX;
            }
        }
        if (this.props.offsetY && !this.isIgnoreOffsetY()) {  // 调整y轴offset
            if (config.top) {
                config.top += this.props.offsetY;
            } else if (config.bottom) {
                config.bottom -= this.props.offsetY;
            }
        }
    }

    private isIgnoreOffsetY() {
        return this.props.ignoreBottomOffsetY && this.alignment === 'bottom';
    }

    private handleAutoOffset(dropRect, anchorRect, config, vh) {
        if (this.props.autoOffsetMode) {
            const model = this.props.autoOffsetMode;
            if (model === 1 && dropRect.width > anchorRect.width) {
                const autoOffsetY = this.props.autoOffsetY || 0;
                if (config.bottom) {
                    config.bottom -= autoOffsetY;
                }
            }
            // 定位超出页面时贴页面边缘定位
            if (config.bottom) {
                config.bottom = Math.min(vh - dropRect.height + 1, config.bottom);
            }
            if (config.top) {
                config.top = Math.min(vh - dropRect.height - 1, config.top);
            }
        }
    }

    // 位置自动调整
    private autoAdjustLoc = (newConfig?) => {
        newConfig = newConfig || this.getNewConfig();
        if (newConfig) {
            this.oldLeft = newConfig.left;
            this.oldRight = newConfig.right;

            this.setState({
                config: newConfig,
            });
        }
    };

    private getID = () => this.id;

    private handleMouseDown = (e) => {
        this.downX = e.clientX;
        this.downY = e.clientY;
    };
}
